var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 20,
    height: 20,
    fill: "#fcfcfc",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-log-in",
    "data-name": "Icon feather-log-in",
    transform: "translate(-2.253 -2.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37945",
    "data-name": "Path 37945",
    d: "M22.5,4.5h3.446a1.723,1.723,0,0,1,1.723,1.723v12.06a1.723,1.723,0,0,1-1.723,1.723H22.5",
    transform: "translate(-7.663)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37946",
    "data-name": "Path 37946",
    d: "M15,19.114l4.307-4.307L15,10.5",
    transform: "translate(-4.47 -2.554)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37947",
    "data-name": "Path 37947",
    d: "M14.837,18H4.5",
    transform: "translate(0 -5.747)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogout);
export default __webpack_public_path__ + "static/media/profile-logout.9043820e2f02f82d708691d8ae41ff56.svg";
export { ForwardRef as ReactComponent };